const jpProcessRouter = [
  {
    path: '/jpprocess/config',
    name: 'jpprocessconfig',
    meta: { c: 'jpschool', a: 'process_config' },
    component: () => import('./config.vue')
  },
  {
    path: '/qcrb/jpprocess/config',
    name: 'qcrb_jpprocessconfig',
    meta: { c: 'qcrb', a: 'process_config' },
    component: () => import('./config.vue')
  }
];

export default jpProcessRouter;
